export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide uppercase mb-3">
            Get in Touch
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Contact the <span className="text-primary-600">Organizers</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 max-w-4xl mx-auto">
          {[
            {
              icon: 'ri-mail-send-line',
              title: 'Email Us',
              detail: 'sonanalamnova2026@sonatech.ac.in',
              sub: 'We respond within 24 hours',
              color: 'primary',
            },
            {
              icon: 'ri-phone-line',
              title: 'Call Us',
              detail: '+91 6383586730',
              sub: 'Mon-Fri, 9 AM - 5 PM IST',
              color: 'accent',
            },
            {
              icon: 'ri-map-pin-2-line',
              title: 'Visit Us',
              detail: 'Sona College of Technology',
              sub: 'Junction Main Road, Salem – 636005, Tamil Nadu',
              color: 'primary',
            },
          ].map((item) => (
            <div key={item.title} className="bg-background-50 rounded-2xl p-6 text-center border border-background-200/70">
              <div className={`w-12 h-12 mx-auto rounded-xl flex items-center justify-center mb-4 ${
                item.color === 'primary' ? 'bg-primary-100' : 'bg-accent-100'
              }`}>
                <i className={`${item.icon} text-xl ${
                  item.color === 'primary' ? 'text-primary-600' : 'text-accent-600'
                }`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-sm font-medium text-foreground-800 mb-1">{item.detail}</p>
              <p className="text-xs text-foreground-500">{item.sub}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3913.039624025534!2d78.1459826!3d11.6643266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babf1c26af6b9b3%3A0x92afd074c9c4e112!2sSona%20College%20of%20Technology!5e0!3m2!1sen!2sin!4v1754900000000!5m2!1sen!2sin"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen
              loading="eager"
              referrerPolicy="no-referrer-when-downgrade"
              title="Sona College of Technology, Salem Location"
              className="w-full"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}